module.exports = __webpack_public_path__ + "static/media/create_job.10097d19.png";